(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[520],{

/***/ 7214:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses",
      function () {
        return __webpack_require__(8883);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _data__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5002);



const Tag = (param)=>{
    let { tag  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "topics/".concat(tag),
        className: "m-1 rounded-full bg-gray-200 px-1 py-1 text-sm dark:bg-gray-900",
        children: tag
    });
};
const CourseCard = (param)=>{
    let { course  } = param;
    const { id , name , price , hours , link , tags , startDate , endDate , days , intensity , type , description , descriptionExtra , active , groupSize , isPopular  } = course;
    const tagList = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
        children: [
            "Tags:",
            tags.map((tag)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
                    tag: tag
                }, tag))
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "my-background relative flex max-w-none flex-col overflow-hidden",
        children: [
            isPopular && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute right-0 top-0 h-16 w-16",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute left-[-65px] top-[28px] w-[180px] rotate-45 transform bg-darkLevander py-1 text-center font-semibold text-white shadow-lg",
                    children: "Populiarus"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                id: id,
                children: name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: description
            }),
            descriptionExtra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "py-2",
                children: descriptionExtra
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        children: [
                            "Trukmė: ",
                            hours,
                            " valandų"
                        ]
                    }),
                    active ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        className: "transition-border self-end rounded-md bg-mustard p-3 text-lg font-bold uppercase transition-colors duration-1000 dark:bg-green-500 dark:text-black",
                        // bg-gradient-to-br from-white via-white to-gray-50
                        href: "courses/".concat(link),
                        children: "Detaliau"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "transition-border self-end rounded-md bg-mustard p-3 text-lg font-bold transition-colors duration-1000 dark:bg-green-500 dark:text-black",
                        // bg-gradient-to-br from-white via-white to-gray-50
                        href: _data__WEBPACK_IMPORTED_MODULE_2__/* ["default"].links.generalRegistrationForm */ .Z.links.generalRegistrationForm,
                        rel: "noopener noreferrer",
                        target: "_blank",
                        children: "Teirautis"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CourseCard);


/***/ }),

/***/ 5002:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const data = {
    links: {
        freePythonLectureRegistration: "https://forms.gle/BZyWuCnFAUvKbDot5",
        generalRegistrationForm: "https://formfaca.de/sm/QwkYhS7Wm"
    },
    courseTopics: [
        {
            id: "pb",
            name: "Python pradedantiesiems",
            description: "Course for someone",
            price: 400,
            hours: 40
        }
    ],
    courses: [
        {
            isPopular: true,
            id: "p-b",
            name: "Python pradedantiesiems",
            tags: [
                "python",
                "data-analysis",
                "beginner"
            ],
            type: "Dieninis",
            days: "PATKPxx",
            groupSize: [
                8,
                16
            ],
            intensity: 40,
            price: 330,
            hours: 40,
            startDate: "2022-11-21",
            description: "Python yra populiariausia pasaulyje programavimo kalba. Python kodas yra lengvai skaitomas, o taikymo sričių - begalė, įskaitant tinklalapių kūrimą, mašininį mokymąsį, automatizavimą ir t.t. Šis kursas puikiai tinka norintiems įgauti Python programavimo pagrindus ir pasirinkti tolimesnę kryptį.",
            // descriptionExtra:
            //   "Šis kursas yra paremtas partnerių, pagal jį paruošta 500 studentų Vokietijoje.",
            link: "python-beginner",
            active: true,
            // https://schema.org/CourseInstance
            courseInstances: [
                // {
                //   courseMode: "online",
                //   startDate: "2022-11-28",
                //   endDate: "2022-12-02",
                //   isAccessibleForFree: false,
                //   courseWorkload: "40 kontaktinių valandų",
                //   instructor: { "@type": "Person", name: "Aidis Stukas" },
                //   eventAttendanceMode: "online",
                //   organizer: { "@type": "Organization", name: "Pirmas kodas" },
                //   offers: {
                //     "@type": "Offer",
                //     availability: "https://schema.org/InStock",
                //     price: 330,
                //     priceCurrency: "EUR",
                //     // url: "http://www.ticketfly.com/purchase/309433",
                //   },
                //   extraType: "dieninė",
                //   extraTypeEmoji: "🏙️",
                //   extraDayTime: "DD, 09:00-17:00 su pertrauka",
                //   // Todo later
                //   // eventSchedule: {},
                // },
                // {
                //   courseMode: "online",
                //   startDate: "2023-01-23",
                //   endDate: "2023-02-17",
                //   isAccessibleForFree: false,
                //   courseWorkload: "40 kontaktinių valandų",
                //   instructor: { "@type": "Person", name: "Aidis Stukas" },
                //   eventAttendanceMode: "online",
                //   organizer: { "@type": "Organization", name: "Pirmas kodas" },
                //   offers: {
                //     "@type": "Offer",
                //     availability: "https://schema.org/InStock",
                //     price: 330,
                //     priceCurrency: "EUR",
                //     // url: "http://www.ticketfly.com/purchase/309433",
                //   },
                //   extraType: "vakarinė",
                //   extraTypeEmoji: "🌆",
                //   extraDayTime: "DD, 18:00-20:00",
                //   // Todo later
                //   // eventSchedule: {},
                //   order: 2,
                // },
                // {
                //   courseMode: "online",
                //   startDate: "2023-01-28",
                //   endDate: "2022-02-19",
                //   isAccessibleForFree: false,
                //   courseWorkload: "40 kontaktinių valandų",
                //   instructor: { "@type": "Person", name: "Aidis Stukas" },
                //   eventAttendanceMode: "online",
                //   organizer: { "@type": "Organization", name: "Pirmas kodas" },
                //   offers: {
                //     "@type": "Offer",
                //     availability: "https://schema.org/InStock",
                //     price: 330,
                //     priceCurrency: "EUR",
                //     // url: "http://www.ticketfly.com/purchase/309433",
                //   },
                //   extraType: "savaitgalinė",
                //   extraTypeEmoji: "☀️",
                //   extraDayTime: "Šeštadieniais, 10:00-13:00",
                //   // Todo later
                //   // eventSchedule: {},
                //   order: 2,
                // },
                {
                    courseMode: "online",
                    startDate: "2023-03-27",
                    endDate: "2023-04-14",
                    isAccessibleForFree: false,
                    courseWorkload: "40 kontaktinių valandų",
                    instructor: {
                        "@type": "Person",
                        name: "Aidis Stukas"
                    },
                    eventAttendanceMode: "online",
                    organizer: {
                        "@type": "Organization",
                        name: "Pirmas kodas"
                    },
                    offers: {
                        "@type": "Offer",
                        availability: "https://schema.org/InStock",
                        price: 600,
                        priceCurrency: "EUR"
                    },
                    extraType: "dieninė",
                    extraTypeEmoji: "\uD83C\uDFD9️",
                    extraDayTime: "10:00-12:00 darbo dienomis",
                    // Todo later
                    // eventSchedule: {},
                    order: 1
                }
            ],
            position: 1
        },
        {
            id: "p-da",
            name: "Duomenų analizė su Python",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 800,
            hours: 80,
            startDate: "2022-10-02",
            endDate: "2022-10-20",
            description: "Python programavimo kalba yra lyderė duomenų analizės srityje. Versle Python keičia ir papildo Excel bei kitas duomenų analizės priemonės. Baigę šį kursą galėsite mikliai naršyti, tvarkyti, analizuoti ir pristatyti duomenis su Python. Baigę šį kursą galėsite studijuoti mašininį mokymąsį.",
            link: "duomenu-analitika-su-python",
            active: true,
            position: 2
        },
        {
            id: "p-ds",
            name: "Duomenų mokslas ir mašininis mokymasis su Python",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 1200,
            hours: 80,
            startDate: "2022-10-02",
            endDate: "2022-10-20",
            description: "Tai žingsnis po duomenų analitikos. Susipažinsime su mašininiu mokymusi. Įvaldysime sklearn biblioteką. Susipažinsime su Xgboost, LightGbm bei neuroninių tinklų bibliotekomis (TensorFlow, Pytorch).",
            link: "masininis-mokymasis-su-python",
            active: true,
            position: 3
        },
        {
            id: "p-wd-be",
            name: "Backend Web dev su Python (Django arba FastAPI)",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 800,
            hours: 80,
            description: "Norite kurti web aplikacijas? Python turi bent keletą tam skirtų bibliotekų. Šis kursas labiausiai tinka tiems, kurie mėgsta dirbi su duomenimis ir neturi noro gilintis į dizainą ir UX/UI klausimus. Baigę šį kursą galėsite kuri web aplikacijų backend dalį.",
            link: "tinklalapiu-kurimas-su-python",
            active: true,
            position: 4
        },
        {
            id: "p-wd-fs",
            name: "Full stack Web dev su Python ir Javascript (React, Tailwind)",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 1500,
            hours: 120,
            description: "Full-stackeris žmogus, kuris dažniausiai reikalingas mažoms ir/arba judrioms(agile) kompanijoms. Esant poreikiui galėsite sukurti visą aplikaciją arba galėsite specializuotis į viena iš sričių bet tuo pačiu suprast ką daro kolegos 'kitame gale'.",
            link: "tinklalapiu-kurimas-su-python-ir-react",
            active: true,
            position: 5
        },
        {
            id: "p-ws",
            name: "Web scraping su Python",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 400,
            hours: 40,
            description: "Dažnas IT projektas priklauso nuo duomenų. Vieša paslaptis, kad didelė dalis kompanijų duomenis tiesiog renka iš interneto. Tai sena praktika, bet besikeičianti kiekvienais metais. Išmoksime įvairių scraping technikų. Baigę kursą galėsite sukurti sprendimą kuris nuolat tvarkingai ir patikimai surenka duomenis iš vieno ar net kelių šaltinių.",
            link: "web-scraping-su-python",
            active: true,
            position: 6
        }
    ]
};
/* harmony default export */ __webpack_exports__["Z"] = (data);


/***/ }),

/***/ 8883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_courseCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5857);
/* harmony import */ var _components_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5002);





const CoursesIndex = ()=>{
    const schema = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "Programavimo kursai",
        itemListElement: _components_data__WEBPACK_IMPORTED_MODULE_4__/* ["default"].courses.map */ .Z.courses.map((course)=>{
            return {
                "@type": "ListItem",
                position: course.position,
                url: "courses/".concat(course.link)
            };
        })
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Pirmas kodas | Kursai"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        // TODO autogenerate from course names
                        content: "Pirmas kodas siūlomi kursai: Python pradedantiesiems, Duomenų analizė su Python, Duomenų mokslas ir mašininis mokymasis su Python, Backend Web Dev su Python, Full stack Web Dev su Python ir Javascript (React, Tailwind) ir Web scraping su Python."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                id: "schemaCourses",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schema)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                className: "prose max-w-none dark:prose-invert prose-h2:mt-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: "Kursai"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "grid grid-cols-1 gap-3",
                        children: _components_data__WEBPACK_IMPORTED_MODULE_4__/* ["default"].courses.map */ .Z.courses.map((course)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_courseCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                course: course
                            }, course.id))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CoursesIndex);


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3573)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(7214); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);